<template>
  <div class="library-folder" @click="$emit('load-directory',id)">
    <div class="library-folder__icon">
      <v-icon>bhi-folder-filled</v-icon>
    </div>
    <div class="library-folder__name">
      <h6 v-if="name.length<25" class="short">{{name}}</h6>
      <v-tooltip v-else bottom open-delay="200">
        <template v-slot:activator="{ on, attrs }">
          <h6 v-if="name.length<=46" class="long">{{name}}</h6>
          <h6 v-else class="long" v-bind="attrs"
              v-on="on">{{name.substring(0,46) + "..."}}</h6>
        </template>
        <span>{{ name }}</span>
      </v-tooltip>
      <span class="library-folder__name--count">
        {{count}} items
      </span>
    </div>
    <div class="library-folder__more">
      <library-more-menu
        :id="id"
        :version="version"
        :name="name"
        :menu="menuHandler"
        :modalDirectory="modalDirectory"
        :is-folder-locked="locked"
        :type="'folder'"
        @changeMenuType="changeMenu"
        v-on="$listeners"
      ></library-more-menu>
    </div>
  </div>
</template>
<script>
import LibraryMoreMenu from '@/components/library/LibraryMoreMenu.vue';
export default {
  name: 'LibraryFolder',
  components: {
    LibraryMoreMenu
  },
  data () {
    return {
      menuHandler: false
    }
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    thumbnailUrl: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    count: {
      type: Number,
      default: 0
    },
    version: {
      type: Number,
      default: 0
    },
    locked: {
      type: Boolean,
      default: false
    },
    modalDirectory: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    changeMenu(type) {
      this.menuHandler = type
    },
  }
}
</script>
